export function getCountries(){
return [
  { 'id': 'LT', 'name': 'Lietuva' },
  { 'id': 'AT', 'name': 'Österreich' },
  { 'id': 'BE', 'name': 'België' },
  { 'id': 'BG', 'name': 'България' },
  { 'id': 'HR', 'name': 'Hrvatska' },
  { 'id': 'CY', 'name': 'Κύπρος' },
  { 'id': 'CZ', 'name': 'Česko' },
  { 'id': 'DK', 'name': 'Danmark' },
  { 'id': 'EE', 'name': 'Eesti' },
  { 'id': 'FI', 'name': 'Suomi' },
  { 'id': 'FR', 'name': 'France' },
  { 'id': 'DE', 'name': 'Deutschland' },
  { 'id': 'GR', 'name': 'Ελλάδα' },
  { 'id': 'HU', 'name': 'Magyarország' },
  { 'id': 'IE', 'name': 'Éire' },
  { 'id': 'IT', 'name': 'Italia' },
  { 'id': 'LV', 'name': 'Latvija' },
  { 'id': 'LU', 'name': 'Lëtzebuerg' },
  { 'id': 'MT', 'name': 'Malta' },
  { 'id': 'NL', 'name': 'Nederland' },
  { 'id': 'PL', 'name': 'Polska' },
  { 'id': 'PT', 'name': 'Portugal' },
  { 'id': 'RO', 'name': 'România' },
  { 'id': 'SK', 'name': 'Slovensko' },
  { 'id': 'SI', 'name': 'Slovenija' },
  { 'id': 'ES', 'name': 'España' },
  { 'id': 'SE', 'name': 'Sverige' },

  { 'id': 'AF', 'name': 'افغانستان' },
  { 'id': 'AL', 'name': 'Shqipëria' },
  { 'id': 'DZ', 'name': 'الجزائر' },
  { 'id': 'AD', 'name': 'Andorra' },
  { 'id': 'AO', 'name': 'Angola' },
  { 'id': 'AR', 'name': 'Argentina' },
  { 'id': 'AM', 'name': 'Հայաստան' },
  { 'id': 'AU', 'name': 'Australia' },
  { 'id': 'AZ', 'name': 'Azərbaycan' },
  { 'id': 'BH', 'name': 'البحرين' },
  { 'id': 'BD', 'name': 'বাংলাদেশ' },
  { 'id': 'BY', 'name': 'Беларусь' },
  { 'id': 'BJ', 'name': 'Bénin' },
  { 'id': 'BO', 'name': 'Bolivia' },
  { 'id': 'BR', 'name': 'Brasil' },
  { 'id': 'CA', 'name': 'Canada' },
  { 'id': 'CL', 'name': 'Chile' },
  { 'id': 'CN', 'name': '中国' },
  { 'id': 'CO', 'name': 'Colombia' },
  { 'id': 'CU', 'name': 'Cuba' },
  { 'id': 'EG', 'name': 'مصر' },
  { 'id': 'IN', 'name': 'भारत' },
  { 'id': 'ID', 'name': 'Indonesia' },
  { 'id': 'IR', 'name': 'ایران' },
  { 'id': 'IQ', 'name': 'العراق' },
  { 'id': 'IL', 'name': 'יִשְרָאֵל' },
  { 'id': 'JP', 'name': '日本' },
  { 'id': 'KE', 'name': 'Kenya' },
  { 'id': 'KR', 'name': '대한민국' },
  { 'id': 'LY', 'name': 'ليبيا' },
  { 'id': 'MX', 'name': 'México' },
  { 'id': 'MA', 'name': 'المغرب' },
  { 'id': 'NG', 'name': 'Nigeria' },
  { 'id': 'NO', 'name': 'Norge' },
  { 'id': 'NZ', 'name': 'New Zealand' },
  { 'id': 'PK', 'name': 'پاکستان' },
  { 'id': 'RU', 'name': 'Россия' },
  { 'id': 'SA', 'name': 'السعودية' },
  { 'id': 'RS', 'name': 'Србија' },
  { 'id': 'CH', 'name': 'Schweiz' },
  { 'id': 'TR', 'name': 'Türkiye' },
  { 'id': 'UA', 'name': 'Україна' },
  { 'id': 'GB', 'name': 'United Kingdom' },
  { 'id': 'US', 'name': 'United States' },
  { 'id': 'VN', 'name': 'Việt Nam' },
  { 'id': 'ZA', 'name': 'South Africa' }
]
}



// WEBPACK FOOTER //
// ./src/js/utils/countries.js